// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import GAuth from 'vue-google-oauth2'
import filters from '@/filters'
import BootstrapVue from 'bootstrap-vue'
import Multiselect from 'vue-multiselect'
import Toastr from 'vue-toastr'
import PrettyCheckbox from 'pretty-checkbox-vue'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.config.productionTip = false
// scope: 'https://www.googleapis.com/auth/admin.directory.group.readonly'
Vue.use(GAuth, {
  clientId: process.env.GOOGLE_CLIENT_ID + '.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
})

Vue.use(BootstrapVue)
Vue.component('multiselect', Multiselect)
Vue.use(Toastr)
Vue.use(PrettyCheckbox)

// Vue.googleAuth().load()

filters.create(Vue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js